module.exports = __webpack_public_path__ + "04_medium_brown.467829c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/04_medium_brown.png
// module id = iNss
// module chunks = 0